<template>
  <div class="wholeContext">
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="join container">
        <div class="notification">
          <span class="imgWrap"><img src="../../assets/images/thanq_logo.png" /></span>
          <p>회원탈퇴가 완료되었습니다.</p>
          <p>그동안 땡큐를 사랑해주셔서 감사합니다.</p>
        </div>
      </div>
      <div class="btnWrap visible">
        <button class="" type="button" @click="nextMain()">메인페이지로 이동</button>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '../../components/AppHeader'
import AddPopup from '@/components/AddPopup'
import { mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single',
        nextLink: '',
        closeType: 'close'
      },
      transDate: {
        headerName: '회원탈퇴 완료',
        prevUrl: '/'
      },
      underAgeChecked: false,
      overAgeChecked: false,
      buttonUp: false,
      form: {
        secessionCause: {
          value: [],
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        }
      },
      setCount: false
    }
  },
  created () {
    /* url 직접 접근 막기 */
    if (this.getReferrer.includes('confirmPasswordSecession') !== true) {
      this.SET_POPUP(true)
      this.popupSet.content = '잘못된 접근입니다.'
      this.popupSet.count = 'another'
      this.popupSet.nextLink = '/'
      this.popupSet.closeType = 'action'
      this.popupSet.closeLink = '/'
    }
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
  },
  computed: {
    ...mapGetters('referrer', [
      'getReferrer'
    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  components: {
    AppHeader,
    AddPopup
  },
  methods: {
    ...mapMutations('referrer', [
      'SET_REFERRER'
    ]),
    ...mapMutations([
      'SET_POPUP'
    ]),
    nextMain () {
      this.$router.push('/')
    },
    callPrev () {
      if (this.setCount) {
        this.$router.push('/')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  beforeDestroy () {
    this.setCount = false
    this.SET_POPUP(false)
    this.SET_REFERRER('')
  }
}
</script>

<style lang="scss" scoped>
</style>
